/* Página de Deos: cápsula que se abre al bajar (ng-poder), oferta final que
   usa el formulario de arriba (ng-oferta-final) y video que arranca solo al
   verse (ng-video-datos). Lo carga snippets/ng-estilo-deos con defer. */
(() => {
  const limitar = (v) => Math.min(1, Math.max(0, v));
  const suave = (t) => t * t * (3 - 2 * t);

  /* ---- Cápsula: el avance de la sección (0 → 1) mueve variables CSS ----
     En PC la cápsula está fija mientras pasa la sección; en celular se mide
     cuando la escena cruza la pantalla. Solo transform y opacity. */
  const iniciarPoder = () => {
    document.querySelectorAll('[data-ng-poder]').forEach((sec) => {
      if (sec.dataset.ngListo) return;
      sec.dataset.ngListo = '1';
      const capsula = sec.querySelector('[data-ng-poder-capsula]');
      const escena = sec.querySelector('.ng-poder__escena');
      if (!capsula || !escena) return;
      const pc = window.matchMedia('(min-width: 990px)');

      let pendiente = false;
      let visible = false;
      const pintar = () => {
        pendiente = false;
        const vh = window.innerHeight;
        let p;
        if (pc.matches) {
          const r = sec.getBoundingClientRect();
          p = limitar((vh * 0.55 - r.top) / Math.max(1, r.height - vh * 0.45));
        } else {
          const r = escena.getBoundingClientRect();
          p = limitar((vh * 0.92 - r.top) / (vh * 0.75));
        }
        const gira = suave(limitar(p / 0.45));
        const abre = suave(limitar((p - 0.4) / 0.3));
        const polvo = suave(limitar((p - 0.48) / 0.25));
        const s = capsula.style;
        s.setProperty('--rot', (-32 + 32 * gira + (p > 0.75 ? (p - 0.75) * 24 : 0)).toFixed(2));
        s.setProperty('--sube', (1 - abre).toFixed(3));
        s.setProperty('--tapa', (46 - abre * 60).toFixed(2));
        s.setProperty('--base', (abre * 7).toFixed(2));
        s.setProperty('--polvo', polvo.toFixed(3));
      };
      const programar = () => {
        if (!visible || pendiente) return;
        pendiente = true;
        requestAnimationFrame(pintar);
      };
      new IntersectionObserver(([en]) => {
        visible = en.isIntersecting;
        if (visible) programar();
      }, { rootMargin: '200px 0px' }).observe(sec);
      // En PC la página se desplaza dentro de un contenedor: escuchar en captura
      document.addEventListener('scroll', programar, { passive: true, capture: true });
      window.addEventListener('resize', programar);
      visible = true;
      pintar();
      visible = false;
    });
  };

  /* ---- Oferta final: marca la oferta en el formulario de arriba y lo envía ---- */
  const iniciarOferta = () => {
    document.querySelectorAll('[data-ng-oferta-final]').forEach((sec) => {
      if (sec.dataset.ngListo) return;
      sec.dataset.ngListo = '1';
      const packs = [...sec.querySelectorAll('[data-ng-of-cantidad]')];
      const radios = () => [...document.querySelectorAll('#ng-product-form input[name="quantity"][type="radio"]')];

      const reflejar = () => {
        const marcada = radios().find((r) => r.checked);
        const cant = marcada ? marcada.value : '1';
        packs.forEach((b) => b.setAttribute('aria-checked', String(b.dataset.ngOfCantidad === cant)));
      };

      const elegir = (cant) => {
        const radio = radios().find((r) => r.value === String(cant));
        if (radio && !radio.checked) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
          radio.dispatchEvent(new Event('input', { bubbles: true }));
        }
        reflejar();
      };

      packs.forEach((b) => b.addEventListener('click', () => elegir(b.dataset.ngOfCantidad)));
      document.addEventListener('change', (e) => {
        if (e.target && e.target.matches && e.target.matches('#ng-product-form input[name="quantity"]')) reflejar();
      });

      const pedir = sec.querySelector('[data-ng-of-pedir]');
      if (pedir) {
        pedir.addEventListener('click', () => {
          const real = document.querySelector('#ng-product-form [data-ng-cta]');
          if (real) { real.click(); return; }
          const form = document.getElementById('ng-product-form');
          if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
        });
      }
      reflejar();
    });
  };

  /* ---- Video: igual que ng-video-texto (sin sonido, arranca al verse) ---- */
  const iniciarVideo = () => {
    const pendientes = new Set();
    const reintentar = () => pendientes.forEach((v) => {
      const p = v.play();
      if (p && p.then) p.then(() => pendientes.delete(v)).catch(() => {});
    });
    ['touchstart', 'pointerdown', 'scroll', 'click'].forEach((ev) =>
      document.addEventListener(ev, reintentar, { passive: true, once: false })
    );
    const cargar = (video) => {
      if (!window.ngVideo) return;
      window.ngVideo.cargar(video, (v) => {
        if (!v.dataset.ngVisible) return;
        const p = v.play();
        if (p && p.catch) p.catch(() => pendientes.add(v));
      });
    };
    document.querySelectorAll('[data-ng-vd-video]').forEach((video) => {
      if (video.dataset.ngListo) return;
      video.dataset.ngListo = '1';
      video.muted = true;
      video.defaultMuted = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('autoplay', '');
      const cerca = new IntersectionObserver(([en]) => {
        if (!en.isIntersecting) return;
        cerca.disconnect();
        cargar(video);
      }, { rootMargin: '1200px 0px' });
      cerca.observe(video);
      new IntersectionObserver(([en]) => {
        video.dataset.ngVisible = en.isIntersecting ? '1' : '';
        if (en.isIntersecting) {
          cargar(video);
          const p = video.play();
          if (p && p.catch) p.catch(() => pendientes.add(video));
        } else if (!video.paused) {
          video.pause();
        }
      }, { threshold: 0.2 }).observe(video);
    });
  };

  /* ---- Botón de sonido del video: lo activa desde el inicio, o lo vuelve a silenciar ---- */
  const iniciarSonido = () => {
    document.querySelectorAll('[data-ng-vd-sonido]').forEach((boton) => {
      if (boton.dataset.ngListo) return;
      boton.dataset.ngListo = '1';
      const video = boton.parentElement.querySelector('[data-ng-vd-video]');
      const texto = boton.querySelector('[data-ng-vd-sonido-texto]');
      const original = texto ? texto.textContent : '';
      if (!video) return;
      boton.addEventListener('click', () => {
        const activar = video.muted;
        video.muted = !activar;
        if (activar) {
          video.currentTime = 0;
          const p = video.play();
          if (p && p.catch) p.catch(() => {});
        }
        boton.setAttribute('aria-pressed', String(activar));
        if (texto) texto.textContent = activar ? 'Silenciar' : original;
      });
    });
  };

  const iniciar = () => {
    iniciarSonido();
    iniciarPoder();
    iniciarOferta();
    iniciarVideo();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
  document.addEventListener('shopify:section:load', iniciar);
})();
